/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiXTdhToken {
    'contract': string;
    'token': number;
    'owner': ApiProfileMin;
    'xtdh': number;
    'xtdh_rate': number;
    'total_contributor_count': number;
    'active_contributor_count': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "token",
            "baseName": "token",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "owner",
            "baseName": "owner",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "xtdh",
            "baseName": "xtdh",
            "type": "number",
            "format": "float"
        },
        {
            "name": "xtdh_rate",
            "baseName": "xtdh_rate",
            "type": "number",
            "format": "float"
        },
        {
            "name": "total_contributor_count",
            "baseName": "total_contributor_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "active_contributor_count",
            "baseName": "active_contributor_count",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiXTdhToken.attributeTypeMap;
    }

    public constructor() {
    }
}
